import classes from "./Contact.module.css";

const Contact = () => {
  return (
    <div className="contacts">
      <div className={classes.contact}>
        <h1>Contact Us</h1>
        <article>
          <div className={classes["contact-box-1"]}>
            <div className={classes["contact-question"]}>
              <p>Country : </p>
              <p>City :</p>
              <p>Language:</p>
            </div>
            <div className={classes["contact-answer"]}>
              <p>India</p>
              <p>New Delhi</p>
              <p>Hindi & English</p>
            </div>
          </div>
          <div className={classes["contact-box-1"]}>
            <div className={classes["contact-question"]}>
              <p>Email : </p>
              <p>Linkedin:</p>
              <p>Instagram:</p>
            </div>
            <div className={classes["contact-answer"]}>
              <address>
                <a href="mailto:abhishekchamoli007@gmail.com">
                  <p>abhishekchamoli007@gmail.com</p>
                </a>
              </address>
              <address>
                <a href="https://www.linkedin.com/in/abhishek-chamoli/">
                  <p>abhishek-chamoli</p>
                </a>
              </address>
              <address>
                <a href="https://www.instagram.com/abhishekchamoli_official/?hl=en">
                  <p>@abhishekchamoli_official</p>
                </a>
              </address>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Contact;
